import React from "react";
import { RaisedButton } from "material-ui";

import EventTable from "./partials/event-table.jsx";
import TagPreview from "./partials/tag-preview.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import BackButton from "./partials/back-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import VenueActions from "../actions/VenueActions";
import VenueStore from "../stores/VenueStore";
import EventActions from "../actions/EventActions";
import EventStore from "../stores/EventStore";

class Venue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      venue: null,
      events: [],
      isFetchingVenue: false,
      fetchedVenue: null,
      showScanCounts: false
    };

    this._onShowScanCountsCheck = this._onShowScanCountsCheck.bind(this);
    this._onRefresh = this._onRefresh.bind(this);
  }

  static getStores() {
    return [VenueStore, EventStore];
  }

  static getPropsFromStores() {
    return {
      getVenueById: VenueStore.getVenueById,
      getEventsForVenue: EventStore.getEventsForVenue,
      isFetchingEvents: EventStore.getState().isFetching
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _onShowScanCountsCheck(checked) {
    this.setState({ showScanCounts: checked });
    EventActions.fetchAllForVenueInBucket(
      this.props.params.venueId,
      this.props.params.eventBucketId,
      /* includeScanCounts */ checked
    );
  }

  _onRefresh() {
    EventActions.fetchAllForVenueInBucket(
      this.props.params.venueId,
      this.props.params.eventBucketId,
      /* includeScanCounts */ this.state.showScanCounts
    );
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var venue = newProps.getVenueById(newProps.params.venueId),
      events = newProps.getEventsForVenue(newProps.params.venueId);

    if (
      !this.state.isFetchingVenue &&
      this.state.fetchedVenue !== newProps.params.venueId
    ) {
      setTimeout(() => {
        VenueActions.fetchOne(newProps.params.venueId);
        EventActions.fetchAllForVenueInBucket(
          newProps.params.venueId,
          newProps.params.eventBucketId,
          /* includeScanCounts */ this.state.showScanCounts
        );
      }, 0);
      this.setState({ isFetchingVenue: true });
    } else if (venue && events) {
      this.setState({ isFetchingVenue: false, fetchedVenue: venue.id });
    }

    this.setState({ venue, events });
  }

  getStyles() {
    return {
      button: {
        marginLeft: 7
      },
      h2: {
        marginTop: 20,
        marginBottom: 10
      }
    };
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.venue) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <div style={{ marginBottom: 20 }}>
          <BackButton
            label={"venues"}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/venues`
                  )
            }
          />
          <RaisedButton
            label="Edit venue"
            onTouchTap={() =>
              this.context.router.push(
                `/event_buckets/${this.props.params.eventBucketId}/venues/${this.props.params.venueId}/edit`
              )
            }
            style={styles.button}
          />
        </div>
        <h1>{this.state.venue.name}</h1>
        <div>
          {this.state.venue.description ? (
            <div>{this.state.venue.description}</div>
          ) : null}
          {this.state.venue.address ? (
            <div>{this.state.venue.address}</div>
          ) : null}
          {this.state.venue.default_capacity ? (
            <div>Default capacity: {this.state.venue.default_capacity}</div>
          ) : null}
          {this.state.venue.use_reserved_seating ? (
            <div>Reserved seating mode</div>
          ) : null}
          {this.state.venue.color ? (
            <span>
              Tag preview:{" "}
              <TagPreview
                label={this.state.venue.short_name || this.state.venue.name}
                color={this.state.venue.color}
              />
            </span>
          ) : null}
        </div>
        <h2 style={styles.h2}>Events at venue</h2>
        <EventTable
          eventBucket={this.props.params.eventBucketId}
          events={this.state.events}
          onShowScanCountsCheck={this._onShowScanCountsCheck}
          onRefresh={this._onRefresh}
          isRefreshing={this.props.isFetchingEvents}
          headerStyle={{ textAlign: "left" }}
        />
      </div>
    );
  }
}

export default connectToStores(Venue);



// WEBPACK FOOTER //
// ./src/app/components/venue.jsx